import React from 'react';
import './FeesSection.css';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router';

const FeesSection = ({ onEnrollClick }) => {
  const navigate = useNavigate();
  const baseFee = 10000;
  const gstPercentage = 18;
  const gstAmount = (baseFee * gstPercentage) / 100;
  const totalFee = baseFee + gstAmount;

  const inclusions = [
    "Full Java Mastery (Basic to Pro)",
    "Analytics Dashboard Access",
    "200+ Live Practical Codes",
    "Professional Certification",
    "Interview Preparation Kit"
  ];

  return (
    <section className="ucp-section ucp-fees">
      <div className="fees-container">
        <motion.div
          className="fees-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="fees-title">Invest in your <span>Future</span></h2>
          <p className="fees-subtitle">Transparent pricing for a comprehensive career transformation.</p>
        </motion.div>

        <div className="fees-content">
          <motion.div
            className="pricing-card horizontal"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="card-badge">Most Popular</div>

            <div className="card-left">
              <div className="price-hld">
                <span className="currency">₹</span>
                <span className="amount">{baseFee.toLocaleString()}</span>
                <span className="suffix">+ 18% GST</span>
              </div>

              <p className="secure-text desktop-only">Secure your seat today. Admission is first-come, first-served.</p>
            </div>

            <div className="card-right">
              <ul className="inclusions-list">
                {inclusions.map((item, index) => (
                  <li key={index} className="inclusion-item">
                    <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>

              <button className="enroll-btn" onClick={onEnrollClick}>
                Admission Open
              </button>

              <p className="secure-text mobile-only">Secure your seat today. Admission is first-come, first-served.</p>
            </div>

            <div className="card-glow"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeesSection;
